const t = "styles-module__month_title_container___4e-5W", e = {
  month_title_container: t
};
export {
  e as default,
  t as month_title_container
};
